var _defs, _rect, _polygon, _polygon2, _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMrskidleeyeballs(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_6",
    "data-name": "Layer 6",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 461.12 407.79",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        fill: none;\n        stroke: #5e5f5e;\n      }\n\n      .cls-1, .cls-2, .cls-3 {\n        stroke-linecap: round;\n        stroke-linejoin: round;\n        stroke-width: 3px;\n      }\n\n      .cls-2 {\n        fill: #e6e6e5;\n        stroke: #e6e6e5;\n      }\n\n      .cls-3 {\n        fill: #b4b4b5;\n        stroke: #b4b4b5;\n      }\n    "))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 200.24,
    y: 101.98,
    width: 111.44,
    height: 44.2
  })), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-3",
    points: "228.25 120.39 225.97 123.43 227.81 126.2 232.15 125.42 232.48 121.75 228.25 120.39"
  })), _polygon2 || (_polygon2 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-3",
    points: "280.66 120.24 278.39 123.28 280.23 126.05 284.57 125.27 284.89 121.6 280.66 120.24"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M286.86,123.7s-2.7-4.11-3.66-4.23-5.18,1.21-5.56,1.88-.24,3.9.14,4.65,4.81,2.44,5.6,2.27,3.43-3.69,3.47-4.57h0Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M224.2,123.7s2.7-4.11,3.66-4.23,5.18,1.21,5.56,1.88.24,3.9-.14,4.65-4.81,2.44-5.6,2.27-3.43-3.69-3.47-4.57h-.01Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMrskidleeyeballs);
export default __webpack_public_path__ + "static/media/mrsk idle eyeballs.48e639ef9439afb420d623d8d1ebaa12.svg";
export { ForwardRef as ReactComponent };